import { render } from "./AttractLink.vue?vue&type=template&id=29e98a73"
import script from "./AttractLink.vue?vue&type=script&lang=js"
export * from "./AttractLink.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__